// extracted by mini-css-extract-plugin
module.exports =  {"chartWrapper":"chartWrapper_i1bXgHei"};